var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M2 7H8V1M18 11V3C18 1.89543 17.1046 1 16 1H8.17495C7.63673 1 7.12122 1.21693 6.74494 1.60176L2.56999 5.8716C2.20459 6.2453 2 6.74719 2 7.26984V19C2 20.1046 2.89543 21 4 21H16C17.1046 21 18 20.1046 18 19V16",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 348"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_64_1158",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 14,
    height: 7,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 14,
    height: 7,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_64_1158)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc.e4fa95c6905d5c12c6d4c5b124ca37d6.svg";